// extracted by mini-css-extract-plugin
module.exports = {"vertical":"N_NnFHnlFHKU1Kwl2YTCy","horizontal":"_2BC2bKf3wkllx_49Ews9LP"};